import {
  ViewContainerRef,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
  OnInit,
  AfterViewInit,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  Injector
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import { NgxExcelColumn } from '../models/models';
import { NgxExcelComponent } from './ngx-excel/ngx-excel.component';

export class NgxExcelTableComponent<T> implements OnInit, OnDestroy, AfterViewInit {

  dataSet: T[];
  columns: NgxExcelColumn[];
  component: ComponentRef<NgxExcelComponent>;

  constructor(
    protected el: ElementRef,
    protected renderer2: Renderer2,
    protected injector: Injector,
    protected cfr: ComponentFactoryResolver,
    protected cdr: ChangeDetectorRef,
    protected viewContainer: ViewContainerRef,
    protected message: NzMessageService
  ) { }

  ngOnInit() {
    // const componentFactory = this.cfr.resolveComponentFactory(NgxExcelComponent);
  }

  ngOnDestroy() {
    if (!this.component) { return; }
    this.component.destroy();
  }

  ngAfterViewInit() {
    const componentFactory = this.cfr.resolveComponentFactory(NgxExcelComponent);
    // this.component = this.viewContainer.createComponent(componentFactory);
    const componentInjector = Injector.create({ providers: [], parent: this.injector });
    this.component = componentFactory.create(componentInjector);
    if (!this.columns || this.columns.length === 0) {
      this.message.warning('æªå®ä¹è¡¨æ ¼å');
      return;
    }
    this.columns.forEach((column) => this.component.instance.appendColumn(column));
    if (this.dataSet) {
      // this.component
    }
    this.viewContainer.insert(this.component.hostView);
    this.cdr.detectChanges();
  }

}
